import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-apps-intergration',
  templateUrl: './apps-intergration.component.html',
  styleUrls: ['./apps-intergration.component.scss']
})
export class AppsIntergrationComponent implements OnInit {

  @Input() title: string = 'Apps und Integrationen';

  constructor() { }

  ngOnInit() {
  }

}
